import { type MouseEvent } from 'react'
import usePreventLeaveSpace from '../CustomPreventNavigate/usePreventLeaveSpace'
import type {
  GENERAL,
  MEMBERS
} from '../routes'
import { SPACES } from '../routes'
import StyledLink from '../StyledLink'

interface Props {
  spaceId: string
  mode: typeof GENERAL | typeof MEMBERS
}

const LinkToEditGeneralSpace = ({
  spaceId,
  mode
}: Props) => {
  const navTo = `/${SPACES}/${spaceId}/${mode}`

  const {
    getLeaveSpaceConfirmation,
    Confirmation
  } = usePreventLeaveSpace({
    navTo
  })

  const handleClick = (event: MouseEvent) => {
    event.preventDefault()
    void getLeaveSpaceConfirmation()
  }

  return (
    <>
      <StyledLink
        onClick={handleClick}
        to={navTo}
      >
        Manage
      </StyledLink>
      <Confirmation />
    </>
  )
}

export default LinkToEditGeneralSpace
